import { ExploreFeedType } from './explore-feed-type'

import type { PairMetrics } from '@root/entities/pair/model'

/**
 * The window each list's figures are shown over.
 *
 * It has to be the window the list is ranked on, and it has to be short.
 *
 * Four of the five showed a whole day. A day's figures do not move: a mature
 * pool sitting in Trending reads `TX 16.4K`, and one more trade leaves it at
 * `16.4K` — a hundred trades are needed to reach `16.5K`, and five thousand
 * dollars to move `$2.07M`. Updates were landing every three seconds and
 * nothing on the screen changed for twenty, which is why the terminal looked
 * dead next to gmgn while carrying the same traffic.
 *
 * It was also the wrong number. The screens rank Trending and Top Gainers on
 * the hour and Cooking on five minutes (`feed-rules.ts` in chart-api), so a
 * day's volume beside them described a different list than the one ordered.
 */
export const EXPLORE_LIST_PERIOD_MAP: Record<
  ExploreFeedType,
  PairMetrics.MetricsSpan
> = {
  [ExploreFeedType.New]: '5M',
  [ExploreFeedType.TopGainers]: '1H',
  [ExploreFeedType.Cooking]: '5M',
  [ExploreFeedType.Graduated]: '1H',
  [ExploreFeedType.Trending]: '1H',
  [ExploreFeedType.FinalStretch]: '5M',
}
